import React from 'react'

export const NoMatch = () => {
  return (
    <div className="nomach-container">
      <h1>404, Page Not Found</h1>
    </div>
  )
}
